import { BrowserRouter } from 'react-router-dom';
import './App.css';
import RoutesPath from './routes';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { CssBaseline } from '@mui/material';
import { DarkModeProvider } from "./context/DarkModeContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000,
    },
  },
});

function App() {
  return (
    <DarkModeProvider>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <RoutesPath />
        </BrowserRouter>
      </QueryClientProvider>
    </DarkModeProvider>
  );
}

export default App;
